module.exports = __webpack_public_path__ + "static/media/jira.ae031777.svg";